<!DOCTYPE html>
<html>

<head>
    <meta name="viewport" content="width=device-width, initial-scale=1">
</head>

<body>

    <div class="card">
        <div class="counter">
            <span>{{count}}</span>
        </div>

        <div class="container">
            <br>
            <!-- <h4 [innerHTML]="icon | htmlSanitizer"></h4> -->
            <span style="text-align: center;"><strong>{{cardName}}</strong></span>
        </div>
    </div>

</body>

</html>